/*const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;*/ // WWW.CANAANORTE.COM.BR

const server = process.env.VUE_APP_SERVER; // SUPORTE.CANAANORTE.COM.BR

const menu = [
  {
    text: "Home",
    to: "/",
  },
  {
    text: "Sobre",
    to: "/sobre",
  },
  {
    text: "Recicláveis",
    to: "/reciclaveis",
  },
  {
    text: "Resíduos",
    to: "/residuos",
  },
  {
    text: "Parceiros",
    to: "/parceiros",
  },
  {
    text: "Prêmio Atitudes",
    to: "/premio-atitudes",
    blank: true,
  },
  {
    text: "Notícias",
    to: "/noticias",
  },
  {
    text: "Contato",
    to: "/contato",
  },
];

export { server, menu };
